import styled, { createGlobalStyle } from 'styled-components';
import { media } from '@minecraft.themes';
import { ThemeProps } from '@consumer-talent.interfaces/styled-theme';

export const AppGlobalStyles = createGlobalStyle<ThemeProps>`
  html, body {
    font-family: 'IBM Plex Sans', sans-serif;
    > div:first-child {
      height: 100%;
    }
    ${media.md`
      height: 100%;
      overflow: auto;
    `}
  }
  html {
    box-sizing: border-box;
    font-size: 1rem;
  }
  body {
    padding: 0;
    margin: 0;
    line-height: 2;
  }
  a:not(.active) {
    text-decoration: none;
    color: ${(props) => props.theme.colors.primary.primary};
  }
  .form-check-input {
    position: relative;
    margin-top: 0;
    margin-left: 0;
  }
  input[type="checkbox"], input[type="radio"] {
    margin: 3px 0.5ex;
  }
  .form-check {
    padding: 0;
  }
`;

export const AnchorStyle = styled.span`
  cursor: pointer;
  text-decoration: none;
  color: ${(props) => props.theme.colors.primary.primary};
`;

export const UnloggedWrapper = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
`;

export const TalentPageHeading = styled.div`
  font-size: 1.875rem;
  font-weight: 600;
  border-bottom: 0.0625rem solid ${(props): string => props.theme.colors.accent.ltGrey3};
  padding: 0.5rem 1.875rem;
  margin: 0 -1.875rem;
  line-height: 1.5;
  ${media.md`
    line-height: 2;
  `}
`;

export const StyledTitle = styled.div`
  font-size: 1.875rem;
  font-weight: 600;
  padding: 0.5rem;
  margin: 0;
  border-bottom: 0.0625rem solid ${(props): string => props.theme.colors.accent.ltGrey3};
`;
